import styled, { css } from "styled-components";

import Button from "core/Button";
import Messages from "core/Messages";

import { convertPxToRem } from "frontend/components/helpers";
import colors from "core/colors";
import { textSm, medium as mediumFontStyle } from "core/fontStyles";
import { spacingWithBreakpoints } from "core/spacing";
import { BorderBottomLinkStyle } from "core/Typography";

export const DownloadButtonsContainer = styled.div`
    margin-top: ${convertPxToRem({ px: 24 })};
`;

export const DownloadButton = styled(Button).attrs({
    styleType: "cta",
    darkMode: true,
    width: "100%"
})`
    &:first-of-type {
        margin-bottom: ${convertPxToRem({ px: 24 })};
    }
`;

export const DownloadSize = styled.div`
    display: flex;
    justify-content: center;
    color: ${colors.primary.diamond};
    ${textSm}
    ${spacingWithBreakpoints.SMTop}
`;

export const CurrentDownloadSize = styled.div`
    flex: 0 0 auto;
`;

export const ChangeDownloadSize = styled.div`
    flex: 0 0 auto;
    margin-left: ${convertPxToRem({ px: 8 })};
`;

export const linkStyle = css`
    background-color: transparent;
    padding: 0;
    border: none;
    ${BorderBottomLinkStyle}
    color: ${colors.accent.darkMode.suenosBuenos};
    border-bottom-color: ${colors.accent.darkMode.suenosBuenos};

    &:hover {
        color: ${colors.primary.diamond};
        border-bottom-color: ${colors.primary.diamond};
    }
`;

export const OpenSizeOptions = styled.button`
    ${linkStyle}
    ${mediumFontStyle}
    font-size: ${convertPxToRem({ px: 12 })};
    cursor: pointer;
`;

export const ChangeDownloadSizeItem = styled.button`
    ${linkStyle}
    color: ${colors.secondary.oolong};
    border-bottom-color: ${colors.secondary.oolong};

    &:hover {
        color: ${colors.secondary.cosmic};
        border-bottom-color: ${colors.secondary.cosmic};
    }
`;

export const BackLink = styled.button`
    ${linkStyle}
    font-size: ${convertPxToRem({ px: 12 })};
    margin-top: ${convertPxToRem({ px: 30 })};
`;

export const ErrorMessage = styled(Messages).attrs({
    darkMode: true,
    isDismissable: true,
    infoType: "error",
    styleType: "solid"
})`
    margin-top: ${convertPxToRem({ px: 30 })};
`;
